import React from 'react';
import TapSelect from '../../../components/ui/TapSelect';
import tapIcon from '../../../services/TapIcon';
import Ax from "../../../components/hoc/Ax";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Modal } from 'bootstrap';
import Loader from "../../../components/ui/Loader/Loader";
import AppBaseComponent from "../../../components/AppBaseComponent";
import DatePicker from "react-datepicker";
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import AssetMiniDetail from '../../includes/AssetMiniDetail';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import moment from 'moment';
import WarehouseAddress from '../includes/WarehouseAddress';
import { iscApi, server2Api } from '../../../services/api';
import { INVENTORY_API_BASE_URL_2, ISC_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import AddItemModal from '../../items/itemsAdd/AddItemModal';
import ItemEditModal from '../../items/itemsAdd/ItemEditModal';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import ItemSearchModal from '../../items/itemSearchModal';
import AdditionalAttributeForm from '../../includes/ui/AdditionalAttributeForm';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import InputWorkstationSearch from '../../includes/ui/InputWorkstationSearch';
import InputTicketSearch from '../../includes/ui/InputTicketSearch';
import GeneralSelectFor from '../../includes/GeneralSelectFor';

class WarehouseIndentAdd extends AppBaseComponent {
    constructor(props) {
        super(props);

        this.initIndentFormState = {
            transaction_date: moment(new Date(), 'YYYY-MM-DD').toDate(),
            warehouse_id: '',
            status: '',
            title: '',
            indent_for: '',
            workstation_id: '',
            asset_id: '',
            employee_id: '',
            vendor_id: '',
            customer_id: '',
            sub_assembly_id: '',
            users: [],
            ticket_id: ''
        };

        this.state = {
            saveFormSubmitting: false,
            // Initialize with one empty row by default
            storeIndentItemRows: [{ item: null }],
            addStoreIndentForm: { ...this.initIndentFormState },
            selectedAsset: null,
            searchedWorkstation: null,
            searchedEmployee: null,
            selectedVendor: null,
            selectedCustomer: null,
            selectedSubAssembly: null,
            warehouseDetailLoading: false,
            warehouseDetail: null,
            warehouseSites: [],
            allWarehouses: [],
            storeIndentFormDataLoaded: false,
            allStatus: [],
            allIndentOptions: [],
            allWorkstations: [],
            allGstSlabs: [],
            itemRowNumber: 0,
            formData: null,
            indentDetailData: null,
            form_loading: false,
            allUsers: [],
            showItemSearchModal: false,
            showItemAddModal: false,
            showItemEditModal: false,
            settings: null,
            selectedTicket: null,
            allPriorityOptions : [],
            // Flag for bulk loading
            isBulkLoading: false,
            // Store item details for edit
            itemSearchedDetails: null,
            // Add forData state for GeneralSelectFor
            forData: {
                forField: ['asset', 'workstation', 'employee', 'customer', 'sub_assembly'],
                type: 'Indent For',
                warehouseSites: [],
                ticketSelected: false,
                isRequired: false,
                chageWarehouse                  :   false,
                purchaseVendor: null,
                editData: {
                    type: '',
                    selected_asset: null,
                    selected_workstation: null,
                    selected_employee: null,
                    selected_vendor: null,
                    selected_customer: null,
                    selected_subassembly: null,
                    workstation_id: '',
                    asset_id: '',
                    employee_id: '',
                    vendor_id: '',
                    customer_id: '',
                    sub_assembly_id: ''
                }
            }
        };

        // URLs
        this.formDataUrl = `${INVENTORY_API_BASE_URL_2}/warehouse_indent/add_form_data`;
        this.addUrl = `${INVENTORY_API_BASE_URL_2}/warehouse_indent`;
        this.warehouseUrl = `${ISC_API_BASE_URL_2}/warehouse`;
        this.itemUrl = `${INVENTORY_API_BASE_URL_2}/item`;

        // Refs
        this.itemSearchRef = React.createRef();
        this.addItemModalRef = React.createRef();
        this.editItemModalRef = React.createRef();
        this.itemDetailsRef = React.createRef();
        this.viewItemModal = React.createRef();

        // For bulk loading
        this.bulkLoadTimeout = null;
        this.pendingItems = [];
        this.batchSize = 10;
    }

    componentDidMount() {

        this.initializeFormData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.location && this.props.location.state) {
            if (nextProps.all_warehouses !== this.props.all_warehouses) {
                this.initializeFormData(nextProps);
            }
        }
    }

    componentWillUnmount() {
        if (this.bulkLoadTimeout) {
            clearTimeout(this.bulkLoadTimeout);
        }
    }

    // Batch update for bulk loading
    flushBulkUpdates = () => {
        if (this.pendingItems.length > 0) {
            const newRows = [...this.state.storeIndentItemRows];

            this.pendingItems.forEach((itemData, index) => {
                if (newRows[index]) {
                    newRows[index] = {
                        ...newRows[index],
                        ...itemData,
                        _loading: false
                    };
                }
            });

            this.pendingItems = [];

            this.setState({
                storeIndentItemRows: newRows,
                isBulkLoading: false
            });
        }
    };

    scheduleBulkUpdate = () => {
        if (this.bulkLoadTimeout) {
            clearTimeout(this.bulkLoadTimeout);
        }
        this.bulkLoadTimeout = setTimeout(() => {
            this.flushBulkUpdates();
        }, 100);
    };

    addToBulkQueue = (itemData) => {
        this.pendingItems.push(itemData);
        this.scheduleBulkUpdate();
    };

    initializeFormData = (pr) => {
        const sites = this.props.iam_group_sites;

        this.setState({ form_loading: true });

        let headers = { 'Authorization': 'Bearer ' + this.props.access_token };

        server2Api.get(this.formDataUrl, { headers: headers })
            .then((response) => {
                const formData = response.data;

                // Fix: Map warehouses correctly
                const allWarehouses = pr.all_warehouses && pr.all_warehouses.length > 0
                    ? pr.all_warehouses.map((s) => ({
                        value: s.id,
                        label: `${s.name} (${s.code})`,
                        site_ids: s.site_ids || []
                    }))
                    : [];

                this.setState({
                    storeIndentFormDataLoaded: true,
                    formData: formData || null,
                    allWorkstations: formData && formData.workstations
                        ? formData.workstations.map((ws) => {
                            const site = sites.find(gs => gs.id === ws.site_id);
                            return {
                                value: ws.id,
                                label: `${ws.workstation_name}`,
                                workstation: ws
                            };
                        })
                        : [],
                    allIndentOptions: [
                        { value: 'asset', label: 'Asset' },
                        { value: 'workstation', label: 'Workstation' },
                        { value: 'employee', label: 'Employee' },
                        { value: 'vendor', label: 'Vendor' },
                        { value: 'customer', label: 'Customer' },
                        { value: 'sub_assembly', label: 'Sub Assembly' }
                    ],
                    allStatus: formData && formData.status && formData.status.length > 0
                        ? formData.status.map((s) => ({ value: s.id, label: s.name }))
                        : [],
                    allPriorityOptions: formData?.priorities?.length > 0
                            ? formData.priorities.map(s => ({
                                value: s.key,
                                label: s.name
                            }))
                            : [],
                    allWarehouses: allWarehouses,
                    allUsers: formData && formData.users
                        ? formData.users.map((s) => ({
                            value: s.id,
                            label: s.full_name,
                            site_ids: s.linked_sites || []
                        }))
                        : [],
                    settings: formData && formData.settings,
                    isc_prevent_back_day_voucher           :    pr.isc_setting && pr.isc_setting.isc_prevent_back_day_voucher && pr.isc_setting.isc_prevent_back_day_voucher ? pr.isc_setting.isc_prevent_back_day_voucher : 'N',
                }, () => {
                    // Update forData with warehouseSites
                    this.setState({
                        forData: {
                            ...this.state.forData,
                            warehouseSites: this.state.warehouseSites
                        }
                    });

                    this.handleEditMode(pr);
                    this.handleItemDemandData(pr);
                    this.handleTicketData(pr);
                });
            })
            .catch((error) => {
                console.error('Error initializing form data:', error);
            })
            .finally(() => {
                this.setState({ form_loading: false });
            });
    };

    handleEditMode = (pr) => {
        if (pr.location?.state?.indentDetailData) {
            const indentData = pr.location.state.indentDetailData;
            const indentItemRows = indentData.items || [];

            const updateFormState = {};
            if (indentData.additional_attributes_data) {
                indentData.additional_attributes_data.forEach((i) => {
                    updateFormState[`additional_attributes_${i.key}`] = i.value;
                });
            }

            // Prepare selected values
            let selectedAsset = null;
            let searchedEmployee = null;
            let searchedWorkstation = null;
            let selectedVendor = null;
            let selectedCustomer = null;
            let selectedSubAssembly = null;

            if (indentData.assetProfile) {
                selectedAsset = {
                    ...indentData.assetProfile,
                    label: `${indentData.assetProfile.name} (${indentData.assetProfile.asset_code})`
                };
            }
            if (indentData.employee) {
                searchedEmployee = {
                    value: indentData.employee.enc_id,
                    label: indentData.employee.display_full_name
                };
            }
            if (indentData.workstation) {
                searchedWorkstation = {
                    value: indentData.workstation.id,
                    label: indentData.workstation.workstation_name
                };
            }
            if (indentData.vendor) {
                selectedVendor = {
                    value: indentData.vendor.id,
                    label: indentData.vendor.name,
                    display_label: indentData.vendor.name
                };
            }
            if (indentData.customer) {
                selectedCustomer = {
                    value: indentData.customer.id,
                    label: indentData.customer.name,
                    display_label: indentData.customer.name
                };
            }
            if (indentData.subAssembly) {
                selectedSubAssembly = {
                    value: indentData.subAssembly.id,
                    label: indentData.subAssembly.name,
                    display_label: indentData.subAssembly.name
                };
            }

            // Set form data first
            this.setState({
                addStoreIndentForm: {
                    ...this.state.addStoreIndentForm,
                    transaction_date: pr.location.state.clone
                        ? moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD')
                        : indentData.transaction_date,
                    transaction_id: pr.location.state.clone ? '' : indentData?.transaction_id,
                    warehouse_id: indentData.warehouse_id,
                    status: pr.location.state.clone ? null : (indentData.status_data?.id || ''),
                    title: indentData.title,
                    indent_for: indentData.indent_for,
                    asset_id: indentData.assetProfile?.asset_id || null,
                    workstation_id: indentData.workstation?.id || null,
                    employee_id: indentData.employee?.enc_id || null,
                    vendor_id: indentData.vendor?.id || null,
                    priority:indentData.priority || '',
                    due_date:indentData.due_date || '',
                    customer_id: indentData.customer?.id || null,
                    sub_assembly_id: indentData.subAssembly?.id || null,
                    notes: indentData.notes || '',
                    users: indentData.usersList?.map(user => user.enc_id) || [],
                    ...updateFormState,
                    ticket_id: pr.settings?.ticket_warehouse_indent === "Y" ? indentData.ticket_id : ""
                },
                selectedAsset: selectedAsset,
                searchedEmployee: searchedEmployee,
                searchedWorkstation: searchedWorkstation,
                selectedVendor: selectedVendor,
                selectedCustomer: selectedCustomer,
                selectedSubAssembly: selectedSubAssembly,
                selectedTicket: pr.settings?.ticket_warehouse_indent === "Y" && indentData.ticket
                    ? {
                        ...indentData.ticket,
                        value: indentData.ticket.activity_id,
                        label: `${indentData.ticket.activity_id} : ${indentData.ticket.header}`,
                        display_label: `${indentData.ticket.activity_id} : ${indentData.ticket.header}`
                    }
                    : null,
                indentDetailData: pr.location.state.clone ? null : indentData
            }, () => {
                // Update forData with selected values
                this.setState({
                    forData: {
                        ...this.state.forData,
                        ticketSelected: indentData.ticket ? true : false,
                        editData: {
                            type: indentData.indent_for,
                            selected_asset: selectedAsset,
                            selected_workstation: searchedWorkstation,
                            selected_employee: searchedEmployee,
                            selected_vendor: selectedVendor,
                            selected_customer: selectedCustomer,
                            selected_subassembly: selectedSubAssembly,
                            asset_id: indentData.assetProfile?.asset_id || null,
                            workstation_id: indentData.workstation?.id || null,
                            employee_id: indentData.employee?.enc_id || null,
                            vendor_id: indentData.vendor?.id || null,
                            customer_id: indentData.customer?.id || null,
                            sub_assembly_id: indentData.subAssembly?.id || null
                        }
                    }
                });

                this.getWarehouseDetail(indentData.warehouse_id);

                // Handle items with bulk loading for large datasets
                if (indentItemRows.length > 0) {
                    if (indentItemRows.length > 20) {
                        // First create dummy rows (fast render) - preserve the empty row at the end
                        const dummyRows = indentItemRows.map(() => ({
                            item: null,
                            qty: 0,
                            rate: 0,
                            gst: null,
                            remark: '',
                            measuring_unit: '',
                            _loading: true
                        }));
                        // Add one empty row at the end
                        dummyRows.push({ item: null });

                        this.setState({
                            storeIndentItemRows: dummyRows,
                            isBulkLoading: true
                        }, () => {
                            // Process items in batches
                            let processedCount = 0;

                            const processBatch = () => {
                                const startIdx = processedCount;
                                const endIdx = Math.min(processedCount + this.batchSize, indentItemRows.length);

                                for (let i = startIdx; i < endIdx; i++) {
                                    const consumedItem = indentItemRows[i];
                                    this.addToBulkQueue({
                                        item: consumedItem.itemData,
                                        qty: consumedItem.pending_qty || consumedItem.indent_qty,
                                        rate: consumedItem.rate,
                                        gst: consumedItem.gst,
                                        remark: consumedItem.remark || '',
                                        measuring_unit: consumedItem.itemData?.unit_name
                                    });
                                }

                                processedCount = endIdx;

                                if (processedCount < indentItemRows.length) {
                                    setTimeout(processBatch, 50);
                                }
                            };

                            setTimeout(processBatch, 100);
                        });
                    } else {
                        // For fewer items, load normally
                        const newRows = indentItemRows.map((consumedItem) => ({
                            item: consumedItem.itemData,
                            qty: consumedItem.pending_qty || consumedItem.indent_qty,
                            rate: consumedItem.rate,
                            gst: consumedItem.gst,
                            remark: consumedItem.remark || '',
                            measuring_unit: consumedItem.itemData?.unit_name
                        }));
                        // Add one empty row at the end
                        newRows.push({ item: null });

                        this.setState({
                            storeIndentItemRows: newRows
                        });
                    }
                }
            });
        }
    };

    handleItemDemandData = (pr) => {
        if (pr.location?.state?.itemDemandData) {
            const itemDemandData = pr.location.state.itemDemandData;
            const itemDemandRows = itemDemandData.demandData.items || [];
            const indent_for = itemDemandData?.demand_for?.demand_for;
            const ticket = itemDemandData?.demand_for?.ticket;
           

            this.setState({
                addStoreIndentForm: {
                    ...this.state.addStoreIndentForm,
                    transaction_date: moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
                    notes: itemDemandData.notes || "",
                    warehouse_id: itemDemandData?.warehouse_id,
                    asset_id: itemDemandData?.demand_for?.asset_id || "",
                    workstation_id: itemDemandData?.demand_for?.workstation?.id || "",
                    indent_for: ["vendor", "customer"].includes(indent_for) ? "" : indent_for,
                    ticket_id: pr.settings?.ticket_warehouse_indent === "Y" && ticket ? ticket.activity_id : "",
                    title: itemDemandData.demand_for.title,
                    users: itemDemandData.demand_for.tagged_users?.map(u => u.enc_id) || []
                },
                selectedTicket: pr.settings?.ticket_warehouse_indent === "Y" && ticket
                    ? {
                        ...ticket,
                        value: ticket.activity_id,
                        label: `${ticket.activity_id} : ${ticket.header}`,
                        display_label: `${ticket.activity_id} : ${ticket.header}`
                    }
                    : null
            }, () => {
                if (itemDemandData.demand_for.asset) {
                    this.setState({
                        selectedAsset: {
                            ...itemDemandData.demand_for.asset,
                            label: `${itemDemandData.demand_for.asset.name} (${itemDemandData.demand_for.asset.asset_code})`
                        }
                    });
                }
                if (itemDemandData.demand_for.workstation) {
                    this.setState({
                        searchedWorkstation: {
                            value: itemDemandData.demand_for.workstation.id,
                            label: itemDemandData.demand_for.workstation.workstation_name
                        }
                    });
                }

                this.getWarehouseDetail(itemDemandData.demand_for.warehouse_id);

                // Handle items
                if (itemDemandRows.length > 0) {
                    const newRows = itemDemandRows.map(item => ({
                        item: {...item.item_profile,isAddRemark : true},
                        qty: item.pending_qty,
                        rate: item.rate,
                        gst: item.gst,
                          remark: [
        itemDemandData?.demand_for?.transaction_id,
        item.remark
    ].filter(Boolean).join('\n'),
                        measuring_unit: item.item_profile?.unit_name
                    }));
                    // Add one empty row at the end
                    newRows.push({ item: null });

                    this.setState({
                        storeIndentItemRows: newRows
                    });
                }
            });
        }
    };

    handleTicketData = (pr) => {
        const ParamObject = new URLSearchParams(pr.location.search);

        if (ParamObject.get('ticketId')) {
            const storedData = localStorage.getItem('ticketAddToIndent');

            if (storedData) {
                const ticketData = JSON.parse(storedData);
                const ticketFor = ticketData.ticket_for;

                this.setState({
                    addStoreIndentForm: {
                        ...this.state.addStoreIndentForm,
                        indent_for: ticketFor,
                        asset_id: ticketFor === "asset" ? ticketData.asset?.asset_id : null,
                        workstation_id: ticketFor === "workstation" ? ticketData.workStation?.id : null,
                        employee_id: ticketFor === "employee" ? ticketData.employee?.enc_id : null,
                        ticket_id: ticketData.activity_id,
                        users: ticketData.tagged_users_display?.map(u => u.id)
                    },
                    selectedTicket: ticketData
                        ? {
                            value: ticketData.activity_id,
                            label: `${ticketData.activity_id} : ${ticketData.header}`,
                            display_label: `${ticketData.activity_id} : ${ticketData.header}`
                        }
                        : "",
                    allWarehouses: ticketData.site
                        ? pr.all_warehouses.filter(warehouse =>
                            warehouse.site_ids && warehouse.site_ids.includes(ticketData.site.id))
                            .map((s) => ({
                                value: s.id,
                                label: `${s.name} (${s.code})`,
                                site_ids: s.site_ids
                            }))
                        : this.state.allWarehouses
                }, () => {
                    if (ticketData.asset) {
                        this.setState({
                            selectedAsset: {
                                ...ticketData.asset,
                                label: `${ticketData.asset.name} (${ticketData.asset.asset_code})`
                            }
                        });
                    }
                    if (ticketData.employee) {
                        this.setState({
                            searchedEmployee: {
                                value: ticketData.employee.enc_id,
                                label: ticketData.employee.display_full_name
                            }
                        });
                    }
                    if (ticketData.workStation) {
                        this.setState({
                            searchedWorkstation: {
                                value: ticketData.workStation.id,
                                label: ticketData.workStation.name
                            }
                        });
                    }

                    // Ensure one empty row is present
                    this.setState({
                        storeIndentItemRows: [{ item: null }]
                    });
                });
            }
        }
    };

    onWarehouseChange = (selectedOption) => {
        if (!this.state.selectedTicket) {
            this.setState({
                selectedAsset: null,
                searchedWorkstation: null,
                searchedEmployee: null,
                selectedVendor: null,
                selectedCustomer: null,
                selectedSubAssembly: null,
                addStoreIndentForm: {
                    ...this.state.addStoreIndentForm,
                    workstation_id: '',
                    asset_id: '',
                    employee_id: '',
                    vendor_id: '',
                    customer_id: '',
                    sub_assembly_id: '',
                    users: [],
                    warehouse_id : selectedOption ? selectedOption.value : null
                },

               
            }, () => {
                this.getWarehouseDetail(selectedOption ? selectedOption.value : null);
            });
        } else {
             this.setState({
                //  selectedTicket: null,
                //  ticket_id: '',
                addStoreIndentForm : {...this.state.addStoreIndentForm,warehouse_id : selectedOption ? selectedOption.value : null}
             }, () => {
                this.getWarehouseDetail(selectedOption ? selectedOption.value : null);
            });
        }
    };

    getWarehouseDetail = (warehouse_id) => {
        this.setState({
            warehouseSites: []
        }, () => {
            if (warehouse_id) {

                this.setState({
                    warehouseDetailLoading: true,
                    warehouseDetail: null,
                })
                let headers = { 'Authorization': 'Bearer ' + this.props.access_token };

                iscApi.get(`${this.warehouseUrl}/${warehouse_id}`, { headers: headers })
                    .then((response) => {
                        const respData = response.data;
                        const sites = respData.data?.sites?.map(st => st.id) || [];

                        this.setState({
                            warehouseDetail: respData.data,
                            warehouseSites: respData.data?.sites || [],
                            allUsers: this.state.allUsers?.length > 0 && sites.length > 0
                                ? this.state.allUsers.filter(us => us.site_ids?.some(value => sites.includes(value)))
                                : this.state.allUsers
                        }, () => {
                            // Update forData with warehouseSites
                            this.setState({
                                forData: {
                                    ...this.state.forData, // Keep forField, isRequired, etc.
                                    ticketSelected: !!this.state.addStoreIndentForm.ticket_id,
                                    chageWarehouse: !this.state.forData.chageWarehouse,
                                    warehouseSites: this.state.warehouseSites,
                                    // Update editData nested object specifically
                                    editData: {
                                        ...this.state.forData.editData,
                                        // Ensure the type remains consistent
                                        type: this.state.addStoreIndentForm.indent_for
                                    }
                                }
                            });
                        });
                    })
                    .catch((error) => {
                        console.error('Error fetching warehouse detail:', error);
                    })
                    .finally(() => {
                        this.setState({ warehouseDetailLoading: false });
                    });
            } else {
                this.setState({ warehouseDetail: null });
            }
        });
       
    };

    onItemSelect = (selectedItem, key, qty = 1, price = null, addRow = true, edit = false) => {
        if (selectedItem) {
            const itemdata = selectedItem.itemdata;

            // Check for duplicate item
            const existingItem = this.state.storeIndentItemRows.find(
                (req_item, index) => index !== key && req_item.item && req_item.item.id === itemdata.id
            );

            if (existingItem && !edit) {
                toast.error('This Item is already available in this Warehouse Indent, please update the item');
                return;
            }

            const newRows = [...this.state.storeIndentItemRows];

            newRows[key] = {
                item: itemdata,
                qty: qty || newRows[key]?.qty || 0,
                rate: price || itemdata.purchase_price || 0,
                gst: selectedItem.gst || itemdata.gst,
                remark: selectedItem.remark || '',
                measuring_unit: itemdata.unit_name
            };

            this.setState({ storeIndentItemRows: newRows }, () => {
                if (addRow && !this.state.storeIndentItemRows.find(ir => !ir.item)) {
                    setTimeout(() => this.addNewItemRow(), 500);
                }
            });
        }
    };

    addNewItemRow = () => {
        this.setState({
            storeIndentItemRows: [...this.state.storeIndentItemRows, { item: null }]
        });
    };

    removeItemRow = (k) => {
        if (this.state.storeIndentItemRows.length > 1) {
            const newRows = [...this.state.storeIndentItemRows];
            newRows.splice(k, 1);
            this.setState({ storeIndentItemRows: newRows });
        }
    };

    itemSearchModalInit = () => {
        this.setState(prevState => ({ showItemSearchModal: !prevState.showItemSearchModal }), () => {
            if (this.state.showItemSearchModal && this.itemSearchRef.current) {
                const allRows = this.state.storeIndentItemRows;
                const item_ids = allRows.filter(i => i.item).map(item => item.item.id);
                this.itemSearchRef.current.searchItemModalInit(item_ids);
            }
        });
    };

    addRemark = (data, k) => {
        const allRows = [...this.state.storeIndentItemRows];
        const itemdata = { ...data, isAddRemark: true };
        allRows[k] = { ...allRows[k], item: itemdata };
        this.setState({ storeIndentItemRows: allRows });
    };

    editItemModalInit = (data, k) => {
        this.setState(prevState => ({
            showItemEditModal: !prevState.showItemEditModal,
            itemSearchedDetails: data,
            itemRowNumber: k
        }), () => {
            if (this.state.showItemEditModal && this.editItemModalRef.current) {
                this.editItemModalRef.current.itemEditModalInit(data);
            }
        });
    };

    submitEditItem = () => {
        let headers = { 'Authorization': 'Bearer ' + this.props.access_token };

        server2Api.get(`${this.itemUrl}/${this.state.itemSearchedDetails.id}`, { headers: headers })
            .then((response) => {
                const selectedItem = {
                    label: (
                        <Ax>
                            <b>Item : </b> {response.data.data.name} <small> ({response.data.data.item_code})</small><br />
                            <small>
                                <b>Manufacturer : </b> {response.data.data.manufacturer ? response.data.data.manufacturer.name : ''}<br />
                                <b>MPN : </b> {response.data.data.manufacturer_part_no}
                            </small>
                        </Ax>
                    ),
                    value: response.data.data.id,
                    display_label: `${response.data.data.name} (${response.data.data.item_code})`,
                    itemdata: response.data.data
                };

                this.setState({
                    itemSearchedDetails: response.data.data
                }, () => {
                    this.onItemSelect(selectedItem, this.state.itemRowNumber, 1, null, false, true);
                });
            })
            .catch((error) => {
                console.error('Error editing item:', error);
            });
    };

    addItemModalInit = () => {
        this.setState(prevState => ({ showItemAddModal: !prevState.showItemAddModal }), () => {
            if (this.state.showItemAddModal && this.addItemModalRef.current) {
                this.addItemModalRef.current.itemAddModalInit();
            }
        });
    };

    closeEvent = () => {
        this.props.history.push({ pathname: `/warehouse_indent_list` });
    };

    addItemsfromSearch = (selectedItems) => {
        const storeIndentItemRows = selectedItems.map((pu_item) => ({
            item: { ...pu_item.item, isAddRemark: pu_item.remark ? true : false },
            qty: pu_item.qty || 1,
            rate: pu_item.rate || pu_item.item.purchase_price,
            gst: pu_item.gst,
            remark: pu_item.remark || '',
            measuring_unit: pu_item.item.unit_name
        }));

        const allRows = this.state.storeIndentItemRows.filter(i => i.item) || [];
        const indentItemRows = [...allRows, ...storeIndentItemRows];
        // Add one empty row at the end
        indentItemRows.push({ item: null });

        this.setState({ storeIndentItemRows: indentItemRows });
    };

    itemViewModalInit = (item, k) => {
        if (item) {
            this.itemDetailsRef.current?.modalInit(item);
            this.setState({ itemRowNumber: k });
        }
    };

    // FIX: Handle GeneralSelectFor onChange properly
    handleAfterSelectForData = (selectData) => {
        if (selectData) {
            // Update form data based on selection
            const updatedForm = {
                ...this.state.addStoreIndentForm,
                indent_for: selectData.type || '',
                asset_id: selectData.asset_id || '',
                workstation_id: selectData.workstation_id || '',
                employee_id: selectData.employee_id || '',
                vendor_id: selectData.vendor_id || '',
                customer_id: selectData.customer_id || '',
                sub_assembly_id: selectData.sub_assembly_id || ''
            };

            // Update selected states
            const newState = {
                addStoreIndentForm: updatedForm
            };

            if (selectData.type === 'asset') {
                newState.selectedAsset = selectData.selected_asset;
                newState.searchedWorkstation = null;
                newState.searchedEmployee = null;
                newState.selectedVendor = null;
                newState.selectedCustomer = null;
                newState.selectedSubAssembly = null;
            } else if (selectData.type === 'workstation') {
                newState.searchedWorkstation = selectData.selected_workstation;
                newState.selectedAsset = null;
                newState.searchedEmployee = null;
                newState.selectedVendor = null;
                newState.selectedCustomer = null;
                newState.selectedSubAssembly = null;
            } else if (selectData.type === 'employee') {
                newState.searchedEmployee = selectData.selected_employee;
                newState.selectedAsset = null;
                newState.searchedWorkstation = null;
                newState.selectedVendor = null;
                newState.selectedCustomer = null;
                newState.selectedSubAssembly = null;
            } else if (selectData.type === 'vendor') {
                newState.selectedVendor = selectData.selected_vendor;
                newState.selectedAsset = null;
                newState.searchedWorkstation = null;
                newState.searchedEmployee = null;
                newState.selectedCustomer = null;
                newState.selectedSubAssembly = null;
            } else if (selectData.type === 'customer') {
                newState.selectedCustomer = selectData.selected_customer;
                newState.selectedAsset = null;
                newState.searchedWorkstation = null;
                newState.searchedEmployee = null;
                newState.selectedVendor = null;
                newState.selectedSubAssembly = null;
            } else if (selectData.type === 'sub_assembly') {
                newState.selectedSubAssembly = selectData.selected_subassembly;
                newState.selectedAsset = null;
                newState.searchedWorkstation = null;
                newState.searchedEmployee = null;
                newState.selectedVendor = null;
                newState.selectedCustomer = null;
            }

            // If selection is cleared (selectData is null or empty)
            if (!selectData.type) {
                newState.selectedAsset = null;
                newState.searchedWorkstation = null;
                newState.searchedEmployee = null;
                newState.selectedVendor = null;
                newState.selectedCustomer = null;
                newState.selectedSubAssembly = null;
                newState.addStoreIndentForm.indent_for = '';
            }

            this.setState(newState);
        } else {
            // Handle clear selection
            this.setState({
                addStoreIndentForm: {
                    ...this.state.addStoreIndentForm,
                    indent_for: '',
                    asset_id: '',
                    workstation_id: '',
                    employee_id: '',
                    vendor_id: '',
                    customer_id: '',
                    sub_assembly_id: ''
                },
                selectedAsset: null,
                searchedWorkstation: null,
                searchedEmployee: null,
                selectedVendor: null,
                selectedCustomer: null,
                selectedSubAssembly: null
            });
        }
    };

    addStoreIndentFormSubmitEvent = (e, status = 0) => {
        e.preventDefault();

        const items = [...this.state.storeIndentItemRows];
        const additional_attributes = {};

        if (this.state.formData?.additional_attributes) {
            this.state.formData.additional_attributes.forEach((i) => {
                const name = `additional_attributes_${i.key}`;
                additional_attributes[i.key] = this.state.addStoreIndentForm[name] || '';
            });
        }

        const itemsLists = items.filter(i => i.item).map(i => ({
            ...i,
            id: i.item.id,
            item: null,
            qty: i.qty || 0,
            remark: i.remark || ''
        }));

        const addStoreIndentForm = {
            ...this.state.addStoreIndentForm,
            transaction_date: moment(this.state.addStoreIndentForm.transaction_date, 'YYYY-MM-DD').format('YYYY-MM-DD'),
            status: status === 1 ? status : this.state.addStoreIndentForm.status
        };

        const showErrors = [];
        const formData = { ...addStoreIndentForm, items: itemsLists };

        if (!formData.transaction_date) {
            showErrors.push('Please enter Transaction Date.');
        }

        if (!formData.warehouse_id) {
            showErrors.push('Please select Warehouse.');
        }

        if (!formData.status) {
            showErrors.push('Please select Status.');
        }

        if (itemsLists.length === 0) {
            showErrors.push('Please select Item and their qty.');
        } else if (items.some(i => parseFloat(i.qty) <= 0)) {
            showErrors.push('Item quantity must be more than 0.');
        }

        if (showErrors.length > 0) {
            toast.error(showErrors[0]);
        } else {
            this.setState({ saveFormSubmitting: true });

            let headers = { 'Authorization': 'Bearer ' + this.props.access_token };

            const requestData = { ...formData, additional_attributes };
            const apiCall = this.state.indentDetailData
                ? server2Api.put(this.addUrl, requestData, { headers: headers })
                : server2Api.post(this.addUrl, requestData, { headers: headers });

            apiCall
                .then((response) => {
                    toast.success(this.state.indentDetailData
                        ? 'Warehouse Indent updated successfully'
                        : 'Warehouse Indent created successfully');
                    this.props.history.push({ pathname: `/warehouse_indent_list` });
                })
                .catch((error) => {
                    console.error('Error saving warehouse indent:', error);
                })
                .finally(() => {
                    this.setState({ saveFormSubmitting: false });
                });
        }
    };

    handleInputSearchTicket = (selectedOption) => {
        let warehouseList = this.state.allWarehouses;

        if (selectedOption?.data) {
            warehouseList = warehouseList.filter(st =>
                st.site_ids?.length > 0 && st.site_ids.includes(selectedOption.data.site.id)
            );
        } else {
            warehouseList = this.props.all_warehouses?.length > 0
                ? this.props.all_warehouses.map((s) => ({
                    value: s.id,
                    label: `${s.name} (${s.code})`,
                    site_ids: s.site_ids || []
                }))
                : [];
        }

        const ticketFor = selectedOption?.data?.ticket_for || '';


        let selectedAsset = null;
        let searchedWorkstation = null;
        let searchedEmployee = null;
        let searchedSubAssembly = null;
        console.log(selectedOption, 'ffk')

        if (selectedOption?.asset) {
            selectedAsset = {
                ...selectedOption.asset,
                label: `${selectedOption.asset.name} (${selectedOption.asset.asset_code})`
            };
        }

        if (selectedOption?.data?.employee) {
            searchedEmployee = {
                value: selectedOption.data.employee.enc_id,
                label: selectedOption.data.employee.name
            };
        }

        if (selectedOption?.data?.workStation) {
            searchedWorkstation = {
                value: selectedOption.data.workStation.id,
                label: selectedOption.data.workStation.name
            };
        }
        if (selectedOption?.data?.subAssembly) {
            const subAssemblyData = selectedOption.data.subAssembly;
            searchedSubAssembly = {
                value: subAssemblyData.enc_id,
                label: subAssemblyData.name || subAssemblyData.sub_assembly_name || 'Sub Assembly',
                display_label: subAssemblyData.name || subAssemblyData.sub_assembly_name,
                ...subAssemblyData // Include all subAssembly data
            };


        }


        const updatedForData = {
            ...this.state.forData,
            editData: {
                type: ticketFor,
                selected_asset: selectedAsset,
                selected_workstation: searchedWorkstation,
                selected_employee: searchedEmployee,
                selected_vendor: this.state.selectedVendor,
                selected_customer: this.state.selectedCustomer,
                selected_subassembly: searchedSubAssembly,
                asset_id: selectedOption?.asset?.asset_id || '',
                workstation_id: selectedOption?.data?.workStation?.id || '',
                employee_id: selectedOption?.data?.employee?.enc_id || '',
                vendor_id: this.state.addStoreIndentForm.vendor_id || '',
                customer_id: this.state.addStoreIndentForm.customer_id || '',
                sub_assembly_id: selectedOption?.data?.subAssembly?.enc_id || '',
            }
        };

        this.setState({
            addStoreIndentForm: {
                ...this.state.addStoreIndentForm,
                ticket_id: selectedOption?.value || '',
                indent_for: ticketFor,
                workstation_id: selectedOption?.data?.workStation?.id || '',
                employee_id: selectedOption?.data?.employee?.enc_id || '',
                asset_id: selectedOption?.asset?.asset_id || '',
                sub_assembly_id: selectedOption?.data?.subAssembly?.enc_id || '',
                demand_for: ticketFor
            },
            allWarehouses: warehouseList,
            searchedEmployee: searchedEmployee,
            selectedAsset: selectedAsset,
            searchedWorkstation: searchedWorkstation,
            selectedSubAssembly: searchedSubAssembly,
            selectedTicket: selectedOption
                ? {
                    ...selectedOption,
                    asset_id: selectedOption.asset?.asset_id || '',
                    label: selectedOption.display_label,
                    data: selectedOption.data || null
                }
                : "",
            // Update forData with the new editData
            forData: { ...updatedForData, ticketSelected: true }
        }, () => {
            console.log('SubAssembly selected:', this.state.searchedSubAssembly);
            console.log('forData editData:', this.state.forData.editData)
        });
    };

    // handleInputSearchTicket = (selectedOption) => {
    //     let warehouseList = this.state.allWarehouses;

    //     if (selectedOption?.data) {
    //         warehouseList = warehouseList.filter(st =>
    //             st.site_ids?.length > 0 && st.site_ids.includes(selectedOption.data.site.id)
    //         );
    //     } else {
    //         warehouseList = this.props.all_warehouses?.length > 0
    //             ? this.props.all_warehouses.map((s) => ({
    //                 value: s.id,
    //                 label: `${s.name} (${s.code})`,
    //                 site_ids: s.site_ids || []
    //             }))
    //             : [];
    //     }

    //     this.setState({
    //         addStoreIndentForm: {
    //             ...this.state.addStoreIndentForm,
    //             ticket_id: selectedOption?.value || '',
    //             workstation_id: selectedOption?.data?.workStation?.id || this.state.addStoreIndentForm.workstation_id,
    //             employee_id: selectedOption?.data?.employee?.enc_id || this.state.addStoreIndentForm.employee_id,
    //             asset_id: selectedOption?.asset?.asset_id || this.state.addStoreIndentForm.asset_id,
    //             demand_for: selectedOption?.data?.ticket_for || this.state.addStoreIndentForm.demand_for
    //         },
    //         allWarehouses: warehouseList,
    //         searchedEmployee: selectedOption?.data?.employee
    //             ? { value: selectedOption.data.employee.enc_id, label: selectedOption.data.employee.name }
    //             : null,
    //         selectedAsset: selectedOption?.asset
    //             ? { ...selectedOption.asset, label: `${selectedOption.asset.name} (${selectedOption.asset.asset_code})` }
    //             : null,
    //         searchedWorkstation: selectedOption?.data?.workStation
    //             ? { value: selectedOption.data.workStation.id, label: selectedOption.data.workStation.workstation_name }
    //             : null,
    //         selectedTicket: selectedOption
    //             ? {
    //                 ...selectedOption.asset,
    //                 asset_id: selectedOption.asset?.asset_id || '',
    //                 label: selectedOption.display_label,
    //                 data: selectedOption.data || null
    //             }
    //             : ""
    //     });
    // };

    calculateTotals = () => {
        let item_sub_total = 0;
        let item_total_tax = 0;

        this.state.storeIndentItemRows.forEach((row) => {
            if (row.item && row.qty) {
                const total = parseFloat(row.qty) * (row.rate || row.item.purchase_price || 0);
                item_total_tax += total;
            }
        });

        return { item_sub_total, item_total_tax };
    };

    renderItemRow = (item, k) => {
        if (item._loading) {
            return (
                <tr key={`loading-${k}`}>
                    <td className="align-middle">{k + 1}</td>
                    <td colSpan="5" className="text-center">
                        <div className="d-flex align-items-center">
                            <div className="spinner-border spinner-border-sm me-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            Loading item...
                        </div>
                    </td>
                </tr>
            );
        }

        if (!item.item) {
            return (
                <tr key={k}>
                    <td className="align-middle">{k + 1}</td>
                    <td>
                        <InputItemSearch
                            changeEvent={(selectedOption) => {
                                this.onItemSelect(selectedOption, k);
                            }}
                            only_active_item='Y'
                        />
                    </td>
                    <td colSpan="3" className="text-center align-middle">-</td>
                    <td className="align-middle">
                        <a href="#" onClick={(e) => { e.preventDefault(); this.removeItemRow(k); }}>
                            <tapIcon.imageIcon icon={tapIcon.CloseCircleIcon} className="img-fluid" />
                        </a>
                    </td>
                </tr>
            );
        }

        return (
            <tr key={k}>
                <td className="align-middle">{k + 1}</td>
                <td className="text-start">
                    <div className="">
                        <div className="d-flex justify-content-between">
                            <div>
                                <span
                                    className="fw-bold link-primary cursor_pointer"
                                    onClick={() => { this.itemViewModalInit(item.item, k); }}
                                >
                                    {item.item.name}
                                </span>
                            </div>
                            <div>
                                <tapIcon.imageIcon
                                    icon={tapIcon.ListActionIcon}
                                    alt="action-icon"
                                    className="img-fluid pr10 pl10"
                                    data-bs-toggle="dropdown"
                                    href="#"
                                    role="button"
                                    aria-expanded="false"
                                />
                                <ul className="dropdown-menu cursor_pointer">
                                    <li className="dropdown-item" onClick={() => { this.itemViewModalInit(item.item, k) }}>
                                        View Details
                                    </li>
                                    {this.props?.permissions?.permissions?.includes("isc-item-edit") && (
                                        <li className="dropdown-item" onClick={() => {
                                            this.setState({ showItemEditModal: false }, () => {
                                                this.editItemModalInit(item.item, k);
                                            });
                                        }}>
                                            Edit Item
                                        </li>
                                    )}
                                    <li className="dropdown-item" onClick={() => this.addRemark(item.item, k)}>
                                        Add Remark
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="form-text"><b>Code: </b>{item.item.item_code}</div>
                        <div className="form-text">
                            <b>Mfr: </b>{item.item.manufacturer ? item.item.manufacturer.name : '-'}
                            (<b>MPN:</b> {item.item.manufacturer_part_no || '-'})
                        </div>
                        {item.item?.tags?.length > 0 && (
                            <div>
                                {item.item.tags.map((t, idx) => (
                                    <span key={idx} className="badge bg-secondary me-1">{t.name}</span>
                                ))}
                            </div>
                        )}
                    </div>
                    {item.item.isAddRemark && (
                        <textarea
                            name="remark"
                            type="text"
                            value={this.state.storeIndentItemRows[k].remark || ''}
                            onChange={(e) => {
                                const newRows = [...this.state.storeIndentItemRows];
                                newRows[k].remark = e.target.value;
                                this.setState({ storeIndentItemRows: newRows });
                            }}
                            className="form-control mt10"
                            autoComplete="off"
                            placeholder="Item Remarks"
                        />
                    )}
                </td>
                <td className="req_table">
                    <TapInputNumber
                        name="qty"
                        value={this.state.storeIndentItemRows[k].qty}
                        onChange={(newValue) => {
                            const newRows = [...this.state.storeIndentItemRows];
                            newRows[k].qty = newValue;
                            this.setState({ storeIndentItemRows: newRows });
                        }}
                        placeholder="Qty"
                        required={true}
                    />
                    <span className="text-helping input-group-text text-end pr0">
                        {item.item?.measuring_unit?.name || item.measuring_unit}
                    </span>
                </td>
                <td className='text-end'>
                    {item.rate || item.item.purchase_price || 0}
                </td>
                <td className="text-end">
                    {((this.state.storeIndentItemRows[k].qty || 0) * (item.rate || item.item.purchase_price || 0)).toFixed(2)}
                </td>
                <td className="align-middle">
                    <a href="#" onClick={(e) => { e.preventDefault(); this.removeItemRow(k); }}>
                        <tapIcon.imageIcon icon={tapIcon.CloseCircleIcon} className="img-fluid" />
                    </a>
                </td>
            </tr>
        );
    };

    storeIndentItemJsx = () => {
        const totals = this.calculateTotals();

        return (
            <div className="my-3 row">
                <div className="col-12">
                   
                        <table className="table table-bordered table-responsive bg-white">
                            <thead className="table-secondary">
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>S.No</th>
                                    <th scope="col" className="text-center">Item Details</th>
                                    <th scope="col" className="text-center" style={{ width: "12%" }}>Quantity</th>
                                    <th scope="col" className="text-center" style={{ width: "12%" }}>Unit Rate</th>
                                    <th scope="col" className="text-center" style={{ width: "12%" }}>Amount</th>
                                    <th scope="col" className="" style={{ width: "5%" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.isBulkLoading && (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            <div className="d-flex align-items-center justify-content-center py-3">
                                                <div className="spinner-border me-2" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                Loading {this.state.storeIndentItemRows.filter(r => r._loading).length} items...
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {this.state.storeIndentItemRows.map((item, k) => this.renderItemRow(item, k))}
                            </tbody>
                        </table>
                    
                </div>
                <div className="col-12 text-end">
                    {this.state.addStoreIndentForm?.warehouse_id ? (
                        <a
                            role="button"
                            onClick={() => {
                                this.setState({ showItemSearchModal: false }, this.itemSearchModalInit);
                            }}
                            className="link-primary me-3"
                        >
                            <tapIcon.FontAwesomeIcon icon={tapIcon.faSearch} /> Search Item
                        </a>
                    ) : null}
                    {this.props?.permissions?.permissions?.includes("isc-item-add") && (
                        <a
                            role="button"
                            onClick={() => {
                                this.setState({ showItemAddModal: false }, this.addItemModalInit);
                            }}
                            className="link-primary me-3"
                        >
                            <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Item
                        </a>
                    )}
                    <a role="button" onClick={this.addNewItemRow} className="link-primary">
                        <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Row
                    </a>
                </div>
            </div>
        );
    };

    saveStoreIndentFormJsx = () => {
        const totals = this.calculateTotals();
        const transactionDate = this.state.addStoreIndentForm?.transaction_date
            ? moment(this.state.addStoreIndentForm.transaction_date).format('YYYY-MM-DD 00:00:00')
            : null;

        // Update forData with latest values
        const forData = {
            ...this.state.forData,
            warehouseSites: this.state.warehouseSites,
            ticketSelected: this.state.addStoreIndentForm.ticket_id ? true : false,
            editData: {
                type: this.state.addStoreIndentForm.indent_for,
                selected_asset: this.state.selectedAsset,
                selected_workstation: this.state.searchedWorkstation,
                selected_employee: this.state.searchedEmployee,
                selected_vendor: this.state.selectedVendor,
                selected_customer: this.state.selectedCustomer,
                selected_subassembly: this.state.selectedSubAssembly,
                asset_id: this.state.addStoreIndentForm.asset_id,
                workstation_id: this.state.addStoreIndentForm.workstation_id,
                employee_id: this.state.addStoreIndentForm.employee_id,
                vendor_id: this.state.addStoreIndentForm.vendor_id,
                customer_id: this.state.addStoreIndentForm.customer_id,
                sub_assembly_id: this.state.addStoreIndentForm.sub_assembly_id
            }
        };
        

        
        return (
            <form className="bg-white p-3" onSubmit={this.addStoreIndentFormSubmitEvent}>
                <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label require">Date of Indent</label>
                    </div>
                    <div className="col-sm-4 add_calender_section">
                        <DatePicker
                            selected={this.state.addStoreIndentForm.transaction_date
                                ? moment(this.state.addStoreIndentForm.transaction_date, 'YYYY-MM-DD').toDate()
                                : null
                            }
                            name="transaction_date"
                            onChange={(value) => {
                                this.setState({
                                    addStoreIndentForm: {
                                        ...this.state.addStoreIndentForm,
                                        transaction_date: value
                                    }
                                });
                            }}
                            maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                            dateFormat="dd-MMM-yyyy"
                            className="form-control"
                            showMonthDropdown
                            showYearDropdown
                            autoComplete="off"
                            dropdownMode="select"
                            disabled={!!this.state.indentDetailData || this.state.isc_prevent_back_day_voucher == 'Y' ? true : false}
                            placeholderText="Please Enter Date of Transaction"
                        />
                        <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="transaction_date" className="add_calender-icon" />
                    </div>
                </div>

                <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                        <label htmlFor="warehouse_id" className="form-label require">Warehouse</label>
                    </div>
                    <div className="col-sm-7">
                        <TapSelect
                            changeEvent={(selectedOption) => {
                                // this.setState({
                                //     addStoreIndentForm: {
                                //         ...this.state.addStoreIndentForm,
                                //         warehouse_id: selectedOption?.value || ''
                                //     }
                                // });
                                this.onWarehouseChange(selectedOption);
                                
                                
                            }}
                            options={this.state.allWarehouses}
                            isSearchable={true}
                            isClearable={true}
                            required={true}
                            // FIX: Use == for comparison to handle type differences
                            value={this.state.allWarehouses.find(m => m.value == this.state.addStoreIndentForm.warehouse_id)}
                            placeholder="Please Select Warehouse"
                        />
                    </div>
                </div>

                {this.state.warehouseDetail && (
                    <div className="row align-items-center mt1">
                        <div className="offset-3 col-sm-8">
                            <WarehouseAddress warehouseDetail={this.state.warehouseDetail} />
                        </div>
                    </div>
                )}
                {this.state.warehouseDetailLoading && <Loader />}

                <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label require">Status</label>
                    </div>
                    <div className="col-sm-4">
                        <TapSelect
                            changeEvent={(selectedOption) => {
                                this.setState({
                                    addStoreIndentForm: {
                                        ...this.state.addStoreIndentForm,
                                        status: selectedOption?.value || ''
                                    }
                                });
                            }}
                            options={this.state.allStatus}
                            isSearchable={true}
                            isClearable={true}
                            required={true}
                            isDisabled={!!this.state.indentDetailData}
                            value={this.state.allStatus.find(s => s.value == this.state.addStoreIndentForm.status)}
                            placeholder="Select Status"
                        />
                    </div>
                </div>

                <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label">Title</label>
                    </div>
                    <div className="col-sm-4">
                        <input
                            name="title"
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            value={this.state.addStoreIndentForm.title || ''}
                            onChange={(e) => {
                                this.setState({
                                    addStoreIndentForm: {
                                        ...this.state.addStoreIndentForm,
                                        title: e.target.value
                                    }
                                });
                            }}
                            placeholder="Enter Title"
                        />
                    </div>
                </div>
                  <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="site_id" className="form-label ">Priority & Due Date</label>
                                </div>
                                <div className="col-sm-4">
                                    <TapSelect
                                        changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'addStoreIndentForm', 'priority')}
                                        options={this.state.allPriorityOptions}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={this.state.allPriorityOptions.find(s => s.value == this.state.addStoreIndentForm.priority)}
                                        placeholder="Select Priority"
                                    />
                                </div>
                                <div className="col-sm-4 add_calender_section">
                                    <DatePicker
                                        selected={
                                            this.state.addStoreIndentForm.due_date
                                                ? moment(this.state.addStoreIndentForm.due_date, 'YYYY-MM-DD').toDate()
                                                : false
                                        }
                                        name="due_date"
                                        onChange={(value, event) => this.formDateHandler('due_date', value, 'addStoreIndentForm')}
                                        minDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                                        dateFormat="dd-MMM-yyyy"
                                        className={"form-control"}
                                        showMonthDropdown
                                        showYearDropdown
                                        autoComplete="off"
                                        scrollMonthYearDropdown
                                        placeholderText={`Please Enter Due  Date`}
                
                                    />
                
                                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="purchase_date" className="add_calender-icon" />
                                </div>
                            </div>
                
                <div className="row my-3">
                    {/* Use GeneralSelectFor for Indent For with all options */}
                    <GeneralSelectFor
                        forData={forData}
                        afterSelectForData={this.handleAfterSelectForData}
                    />
                </div>
                <div className="row align-items-center mb-3 mt-3">
                    <div className="col-3">
                        <label htmlFor="site_id" className="form-label">Tag Users</label>
                    </div>
                    <div className="col-4">
                        <TapSelect
                            changeEvent={(selectedOption) => {
                                this.setState({
                                    addStoreIndentForm: {
                                        ...this.state.addStoreIndentForm,
                                        users: selectedOption ? selectedOption.map(opt => opt.value) : []
                                    }
                                });
                            }}
                            options={this.state.allUsers}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={this.state.allUsers.filter(t => this.state.addStoreIndentForm.users?.includes(t.value))}
                            placeholder="Please Select User"
                        />
                    </div>
                </div>

                {this.state.settings?.ticket_warehouse_indent === "Y" && (
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="warehouse_id" className="form-label">Ticket</label>
                        </div>
                        <div className="col-sm-4">
                            <InputTicketSearch
                                changeEvent={this.handleInputSearchTicket}
                                placeholder="Search Ticket"
                                search_site_id={this.state.warehouseSites.map(st => st.id)}
                                search_asset_id={this.state.addStoreIndentForm.asset_id}
                                search_employee_id={this.state.addStoreIndentForm.employee_id}
                                search_workstation={this.state.addStoreIndentForm.workstation_id}
                                value={this.state.selectedTicket || ""}
                                search_exclude_ticket_status={[0, 26, 10]}
                            />
                        </div>
                    </div>
                )}

                {this.state.formData?.additional_attributes?.length > 0 && (
                    <AdditionalAttributeForm
                        additionalAttributes={this.state.formData.additional_attributes}
                        formState={this.state.addStoreIndentForm}
                        onAttributeChange={(value, attributeName) => {
                            this.setState({
                                addStoreIndentForm: {
                                    ...this.state.addStoreIndentForm,
                                    [attributeName]: value
                                }
                            });
                        }}
                    />
                )}

                {this.storeIndentItemJsx()}

                <div className="row align-items-center mb-5">
                    <div className="col-6">
                        <label htmlFor="notes" className="form-label">Notes</label>
                        <textarea
                            name="notes"
                            value={this.state.addStoreIndentForm.notes || ''}
                            onChange={(e) => {
                                this.setState({
                                    addStoreIndentForm: {
                                        ...this.state.addStoreIndentForm,
                                        notes: e.target.value
                                    }
                                });
                            }}
                            className="form-control"
                            style={{ height: "100px" }}
                        />
                    </div>
                    <div className="col-6">
                        <label htmlFor="exampleInputEmail1" className="form-label"><p> &nbsp; </p></label>
                        <table className="table table-borderless">
                            <tbody>
                                <tr className="total_bg_color">
                                    <th>Total</th>
                                    <td className="text-end">{(totals.item_sub_total + totals.item_total_tax).toFixed(2)}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="col-12 text-end fixed_footer">
                    <button
                        type="button"
                        disabled={this.state.saveFormSubmitting}
                        onClick={this.closeEvent}
                        className="btn btn-secondary ms-2"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        disabled={this.state.saveFormSubmitting}
                        className="btn btn-secondary ms-2"
                        onClick={(e) => this.addStoreIndentFormSubmitEvent(e, 1)}
                    >
                        Save as a Draft {this.state.saveFormSubmitting && (
                            <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />
                        )}
                    </button>
                    <button
                        type="button"
                        disabled={this.state.saveFormSubmitting}
                        className="btn btn-primary ms-2"
                        onClick={this.addStoreIndentFormSubmitEvent}
                    >
                        Save {this.state.saveFormSubmitting && (
                            <tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />
                        )}
                    </button>
                </div>
            </form>
        );
    };

    render() {
        
        return (
            <ApplicationLayout>
                <Helmet><title>Warehouse Indent - Add</title></Helmet>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3>
                            {this.state.indentDetailData ? "Edit" : "New"} Warehouse Indent
                            {this.state.indentDetailData && (
                                <span> of Transaction ID : {this.state.indentDetailData?.transaction_id}</span>
                            )}
                        </h3>
                        <div className="text-end mt15">
                            <button
                                onClick={this.closeEvent}
                                disabled={this.state.saveFormSubmitting}
                                type="button"
                                className="btn btn-secondary"
                            >
                                <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Requisition" />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="page_containt row pl2">
                        <div className="pageTbl col-12 pl4">
                            {this.state.form_loading ? <Loader /> : this.saveStoreIndentFormJsx()}
                        </div>
                    </div>
                </div>

                {this.state.showItemAddModal && (
                    <AddItemModal parentProps={this.props} ref={this.addItemModalRef} />
                )}

                {this.state.showItemEditModal && (
                    <ItemEditModal
                        parentProps={this.props}
                        ref={this.editItemModalRef}
                        afterSubmitItem={this.submitEditItem}
                    />
                )}

                <ItemDetailsModal ref={this.itemDetailsRef} />

                {this.state.showItemSearchModal && (
                    <ItemSearchModal
                        ref={this.itemSearchRef}
                        afterSelectingItems={(selectedItems) => {
                            const allRows = this.state.storeIndentItemRows.filter(i => i.item) || [];
                            const items = [...allRows, ...selectedItems];
                            // Add one empty row at the end
                            items.push({ item: null });
                            this.setState({ storeIndentItemRows: items });
                        }}
                    />
                )}
            </ApplicationLayout>
        );
    }
}

const mapStateToProps = state => ({
    access_token: state.auth.access_token,
    permissions: state.app.acl_info,
    all_warehouses: state.app?.warehouses || [],
    iam_group_sites: state.app?.group_sites || [],
    settings: state.app.setting,
    isc_setting             :   state.app && state.app.isc_setting ? state.app.isc_setting : null,
});

export default connect(mapStateToProps)(WarehouseIndentAdd);

